import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { domainActions } from '../../store/domainStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { connect as connectFormik } from "formik";
import { withLocalize, Translate } from 'react-localize-redux';
import BbInput from '../styling/bbInput';
import SelectOption from '../searchSections/selectOption';

class RatioBookNaceField extends React.Component {

    nacedatalist = [];

    constructor(props) {
        super(props);
        this.props.ensureDomainData('nace');
    }

    componentDidUpdate() {
        this.props.ensureDomainData('nace');
    }

    render() {
        return (

            <BbInput type='select-noformik' label={this.props.translate('RatioBook.Common.Nace')} placeholder={{ type: 'jumping' }} 
                formatOptionLabel={SelectOption}
                value={(this.getNaceList().find(op => {
                    return op.value === this.props.formik.values[this.props.fieldName]
                }) || {})}
                options={this.getNaceList()}
                onChange={(e) => this.props.formik.setFieldValue(this.props.fieldName, e.value)}
            />
        )
    }

    getNaceList() {
        const naceData = this.props.nace.requestResult ? this.props.nace.requestResult : []

        if (isNullOrUndefined(naceData))
            return null;

        if (this.nacedatalist.length > 0)
            return this.nacedatalist;

        const rawData = naceData.map((c) => {
            const l2 = c.children.map(item => {
                const ll1 = item;
                const ll2 = item.children;
                return [].concat.apply(ll1, ll2);
            });
            return [].concat.apply([], l2);
        });

        const data = [].concat.apply([], rawData.map((c) => c)).map(item => new NaceItem(item.shortening, item.label));
        this.nacedatalist = data;
        return data;
    }
}

class NaceItem {
    constructor(value, label) {
        this.value = this.removeDots(value);
        this.label = label;
    }

    removeDots(text) {
        return text.split('.').join('');
    }
}

export default connectFormik(withLocalize(connect(
    state => state.domain,
    dispatch => bindActionCreators(domainActions, dispatch))
    (RatioBookNaceField)));